const env =
  (window as any).SERVER_DATA && (window as any).SERVER_DATA.env ? (window as any).SERVER_DATA.env : {};

export const NODE_ENV = env.NODE_ENV || "development";
// export const DEBUG_ENABLED = env.DEBUG_ENABLED || 1;
export const DEBUG_ENABLED = 1;
export const API_URL = env.API_URL || "http://localhost:4000";
export const EMBED_URL = env.EMBED_URL || 'http://localhost:3002';
export const GOOGLE_MAPS_API_KEY = env.GOOGLE_MAPS_API_KEY || null;
export const MAPBOX_TOKEN =
  "pk.eyJ1IjoibWlrZXRoZXNlbGxvdXQiLCJhIjoiY2s1ZnZzanRkMDFqMTNwbDNjYmt2OGg3byJ9.ZXejRJcln7vehTgvGieVcg";
export const SENTRY_DSN = env.SENTRY_DSN || '';
export const GOOGLE_TAG_GTM_ID = process.env.GOOGLE_TAG_GTM_ID || 'GTM-NTV9Q4FT'
export const EVENTS_URL = env.EVENTS_URL || 'https://events.sellout.io';
export const HIVE_AUTHORIZATION_URL = env.HIVE_AUTHORIZATION_URL || 'https://app.hive.co/oauth/api/authorize/';
export const HIVE_REDIRECT_URI = env.HIVE_REDIRECT_URI || 'http://localhost:3000/hive/callback';
export const HIVE_SCOPE = env.HIVE_SCOPE || 'events:read events:write orders:read orders:write contacts:read contacts:write';
